import React, { useState, useEffect, useContext } from "react";
import "../css/style.css";
import "../css/login1.css";
import "react-custom-flag-select/lib/react-custom-flag-select.min.css";
import { useNavigate } from "react-router-dom";
import OtpInput from "react-otp-input";
import { subApi, evinaApi } from "../../services/user-api";
import { serviceId, Loader, countryCode, flag } from "../../utils/constant";

const Mtnlb = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [flowLoading, setFlowLoading] = useState(false);
  const [alreadySub, setAlreadySub] = useState(false);
  const [flow, setFlow] = useState("");
  const [phone, setPhone] = useState(sessionStorage.getItem("ugAlias"));
  const [subOption, setSubOption] = useState(1);
  const [plan, setPlan] = useState(1);
  const [autoRenew, setAutoRenew] = useState(1);
  const [price, setPrice] = useState([
    "0",
    "0.10 Cents/Day",
    "0.25 Cents/Week",
    "0.50 Cents/Month",
  ]);
  const [message, setMessage] = useState({ message: "", error: false });
  const [otpId, setOtpId] = useState("");
  const [otp, setOtp] = useState("");
  const [ButtonDisabled, setButtonDisabled] = useState(true);

  useEffect(() => {
    setMessage({ message: "", error: false });
    console.log("phone=" + phone);
    if (phone) {
      setFlowLoading(true);
      subApi({ action: 0, ani: phone, serviceId: serviceId })
        .then((res) => {
          console.log(res);
          if (res.data.data !== null && res.data.data !== undefined) {
            if (res.data.responseCode === 202) // Already Subscribed
            {
              setFlowLoading(false);
              sessionStorage.setItem("token", res.data.data.accessToken);
              window.location.href = "/home";
            } else {
              setFlowLoading(false);
              setFlow("PACK");
            }
          } else {
            setFlowLoading(false);
            setFlow("PACK");
          }
        })
        .catch((err) => {
          console.log(err);
          setFlowLoading(false);
          setFlow("PACK");
        });
    } else setFlowLoading(false);
  }, []);

  const checkStatus = () => {
    console.log("phone=" + phone);
    if (phone) {
      setFlowLoading(true);
      subApi({ action: 0, ani: phone, serviceId: serviceId, mode: "WAP" })
        .then((res) => {
          // console.log(res);
          if (res.data.data !== null && res.data.data !== undefined) {
            if (res.data.responseCode === 202) // Already Subscribed
            {
              setFlowLoading(false);
              sessionStorage.setItem("token", res.data.data.accessToken);
              window.location.href = "/home";
            } else setFlowLoading(false);
          } else setFlowLoading(false);
        })
        .catch((err) => {
          console.log(err);
          setFlowLoading(false);
        });
    } else setFlowLoading(false);
  };
  const handleNumberChange = async (event) => {
    const input = event.target.value;
    if (input.length < 11) setPhone(input);
    setButtonDisabled(input.length < 8);
  };
  const handleRadioChange = async (input) => {
    setPlan(input);
  };
  const handleAutoRenewChange = (input) => {
    setAutoRenew(input);
  };
  const handleSubChange = async (input) => {
    setSubOption(input);
  };
  const handleSubOptionClick = async () => {
    if (subOption == 2) {
      setPlan(3);
    } else {
      setPlan(1);
    }
    setFlow("PACK");
  };
  const cancel = async (input) => {
    setMessage({ message: "", error: false });
    setFlow(input);
  };
  const handleNumInputsChange = (numInputs) => {
    setOtp(numInputs);
    setButtonDisabled(numInputs.length !== 4 || isNaN(numInputs));
  };
  const redirectTo = async (input) => {
    if (input === "/home") {
      checkStatus();
      setFlow("SUCCESS");
    } else navigate(input);
  };
  const handleButtonClick = async () => {
    //console.log(phone);
    setMessage({ message: "", error: false });
    setLoading(true);
    setAlreadySub(false);
    await subApi({
      action: 1,
      serviceId: serviceId,
      planId: plan,
      ani: phone,
      mode: "WAP",
      type: autoRenew,
    })
      .then((res) => {
        console.log(res);
        if (res.data.responseCode === 202) // already sub
        {
          setAlreadySub(true);
          sessionStorage.setItem("token", res.data.data.accessToken);
          setFlow("SUCCESS");
        } else setFlow("SUCCESS");
      })
      .catch((err) => {
        console.log(err);
        setMessage({ message: err.message, error: true });
      })
      .finally(() => setLoading(false));
  };

  /* const sendOtp1 = async() => {
        console.log('phone='+phone);
        setMessage({message: "",error: false});
        if(phone && phone.length>=8)
        {
            var nm=phone;if(nm.length<=10)nm=countryCode+nm
            setLoading(true);
            subApi({action:0,ani: nm,serviceId:serviceId}).then((res) => { 
                    if(res.data.responseCode===202) // already subscribed 
                    {
                        sessionStorage.setItem("token", res.data.data.accessToken);
                        window.location.href ="/home";
                    }
                    else  setFlow("PACK"); 
                setLoading(false);
            }).catch((err) => {
                console.log(err);
                setFlow("PACK");
                setMessage({message: err.message, error: true });
                setLoading(false);
            });
        }
        else if(phone && phone.length>0){setMessage({message: "Please enter a valid number",error: true})}
        else{setMessage({message: "Please enter a number",error: true})}
      };*/

  const sendOtp = async () => {
    console.log("phone=" + phone);
    setMessage({ message: "", error: false });
    if (phone && phone.length >= 8) {
      var nm = phone;
      if (nm.length <= 10) nm = countryCode + nm;
      setLoading(true);
      await subApi({ action: 3, serviceId: serviceId, ani: nm })
        .then((res) => {
          setLoading(false);
          setFlow("OTPCONFIRM");
        })
        .catch((err) => {
          console.log(err);
          setMessage({ message: err.message, error: true });
          setLoading(false);
        });
    } else if (phone && phone.length > 0) {
      setMessage({ message: "Please enter a valid number", error: true });
    } else {
      setMessage({ message: "Please enter a number", error: true });
    }
  };

  const confirmOtp = async () => {
    setMessage({ message: "", error: false });
    if (otp != null && otp.length === 4) {
      var nm = phone;
      if (nm.length <= 8) nm = countryCode + nm;
      setLoading(true);
      await subApi({
        action: 4,
        serviceId: serviceId,
        ani: nm,
        otpId: otpId,
        otp: otp,
      })
        .then((res) => {
          if (res.status === 200) {
            if (res.data.responseCode === 202) // already subscribed
            {
              sessionStorage.setItem("token", res.data.data.accessToken);
              window.location.href = "/home";
            } else {
              setFlow("PACK");
            }
          } else {
            setMessage({ message: res.data.message, error: true });
          }
        })
        .catch((err) => {
          setMessage({ message: err.message, error: true });
        })
        .finally(() => setLoading(false));
    } else {
      setMessage({ message: "OTP is not valid", error: true });
    }
  };
  //{(evinaScript && evinaScript.length>20) && <script type="text/javascript">{evinaScript}</script>}

  return flowLoading ? (
    <Loader />
  ) : (
    <>
      <div className="home">
        <div className="maine-div">
          <div className="container-fluid box-wrapper login">
            <div className="login-header pb-4">
              <div className="box-wrapper mx-auto text-center position-relative">
                <span className="modal-level-title game-title">
                  UVGAMING is the most easy, interesting & engaging gaming
                  platform. The gaming platform is to provide a seamless,
                  convenient, and engaging experience for gamers.
                </span>
              </div>
            </div>
            <div className="login-info">
              <div className="login-thumbnail3">
                <img src="/images/login_img_new.png" alt="UVGames" />
              </div>

              {flow === "PACK" ? (
                <>
                  <div className="pack-select">
                    <div className="pack-card">
                      <h3 className="header-title-green mb-3 text-center">
                        Select subscription plan
                      </h3>
                      <div className="pack-options">
                        <label
                          className={`pack-option${plan === 1 ? " pack-option-active" : ""}`}
                        >
                          <input
                            type="radio"
                            name="plan"
                            value="1"
                            checked={plan === 1}
                            onChange={() => handleRadioChange(1)}
                          />
                          <span className="pack-option-text">
                            0.10 Cents/Day
                          </span>
                        </label>
                        <label
                          className={`pack-option${plan === 2 ? " pack-option-active" : ""}`}
                        >
                          <input
                            type="radio"
                            name="plan"
                            value="2"
                            checked={plan === 2}
                            onChange={() => handleRadioChange(2)}
                          />
                          <span className="pack-option-text">
                            0.25 Cents/Week
                          </span>
                        </label>
                        <label
                          className={`pack-option${plan === 3 ? " pack-option-active" : ""}`}
                        >
                          <input
                            type="radio"
                            name="plan"
                            value="3"
                            checked={plan === 3}
                            onChange={() => handleRadioChange(3)}
                          />
                          <span className="pack-option-text">
                            0.50 Cents/Month
                          </span>
                        </label>
                      </div>
                    </div>

                    <div className="renew-card">
                      <div className="renew-row">
                        <span className="renew-label">Auto Renewal</span>
                        <div className="renew-options">
                          <label
                            className={`renew-option${autoRenew === 1 ? " renew-option-active" : ""}`}
                          >
                            <input
                              type="radio"
                              name="autoRenew"
                              value="1"
                              checked={autoRenew === 1}
                              onChange={() => handleAutoRenewChange(1)}
                            />
                            <span className="renew-option-text">On</span>
                          </label>
                          <label
                            className={`renew-option renew-option-no${autoRenew === 0 ? " renew-option-active" : ""}`}
                          >
                            <input
                              type="radio"
                              name="autoRenew"
                              value="0"
                              checked={autoRenew === 0}
                              onChange={() => handleAutoRenewChange(0)}
                            />
                            <span className="renew-option-text">Off</span>
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="text-center phone-info">
                    {message.message && (
                      <div className="mb-3">
                        <p
                          className={`alert alert-${message.error ? "danger" : "success"}`}
                        >
                          {message.message}
                        </p>{" "}
                      </div>
                    )}
                    {loading ? (
                      <Loader />
                    ) : (
                      <button
                        className="btn btn-primary btn-pm-custom"
                        type="button"
                        onClick={() => setFlow("CONFIRM")}
                      >
                        Subscribe
                      </button>
                    )}
                  </div>
                </>
              ) : flow === "OTPCONFIRM" ? (
                <>
                  <h3 className="login-title mb-3 mt-3 text-center">
                    Enter OTP
                  </h3>
                  <div className="phone-info">
                    <div className="otp_section">
                      <OtpInput
                        value={otp}
                        numInputs={4}
                        renderInput={(props, index) => (
                          <input {...props} type="tel" inputMode="numeric" />
                        )}
                        inputStyle="form-control form-otp"
                        onChange={handleNumInputsChange}
                      />
                    </div>
                    {message.message && (
                      <div className="mb-3">
                        <p
                          className={`alert alert-${message.error ? "danger" : "success"}`}
                        >
                          {message.message}
                        </p>{" "}
                      </div>
                    )}
                    {loading ? (
                      <Loader />
                    ) : (
                      <button
                        className="btn btn-primary btn-pm-custom"
                        type="button"
                        onClick={confirmOtp}
                        disabled={ButtonDisabled}
                      >
                        Confirm
                      </button>
                    )}
                    <div className="resend_otp">
                      <a
                        className="send_otp_link"
                        onClick={() => {
                          cancel("");
                        }}
                      >
                        {" "}
                        &lt;&lt;&nbsp;Back
                      </a>
                    </div>
                  </div>
                </>
              ) : flow === "CONFIRM" ? (
                <>
                  <h3 className="login-title mb-3 mt-3 text-center">
                    You are about to register for the UVGAMING service for{" "}
                    <span className="span-bold">{price[plan]}</span>
                    {autoRenew === 1
                      ? " automatically renewable"
                      : " without auto renewal"}
                  </h3>
                  <h3 className="login-title mb-3 mt-3 text-center">
                    Are you sure you want to continue?
                  </h3>
                  {message.message && (
                    <div className="mb-3">
                      <p
                        className={`alert alert-${message.error ? "danger" : "success"}`}
                      >
                        {message.message}
                      </p>{" "}
                    </div>
                  )}
                  {loading ? (
                    <Loader />
                  ) : (
                    <button
                      className="btn btn-primary btn-pm-green"
                      type="button"
                      onClick={handleButtonClick}
                    >
                      YES
                    </button>
                  )}
                  <button
                    className="btn btn-primary btn-pm-red"
                    type="button"
                    onClick={() => setFlow("")}
                  >
                    NO
                  </button>
                </>
              ) : flow === "SUCCESS" ? (
                <>
                  {alreadySub ? (
                    <h3 className="login-title-green mb-3 mt-3 text-center">
                      You are already subscribed on service.
                    </h3>
                  ) : (
                    <h3 className="login-title-green mb-3 mt-3 text-center">
                      You have successfully subscribed to the service.
                    </h3>
                  )}
                  <h3 className="login-title mb-3 mt-3 text-center">
                    To access the service, click on below 'Click Here' button
                  </h3>
                  {loading ? (
                    <Loader />
                  ) : (
                    <button
                      className="btn btn-primary btn-pm-custom"
                      type="button"
                      onClick={() => {
                        redirectTo("/home");
                      }}
                    >
                      Click Here
                    </button>
                  )}
                </>
              ) : (
                <>
                  <h3 className="login-title mt-3 text-center">
                    Welcome to UVGAMING
                  </h3>
                  <div className="phone-input">
                    <div className="has-validation input-group">
                      <div className="dialing-code">
                        <img
                          src={"https://flagcdn.com/" + flag + ".svg"}
                          width="24"
                          alt="Cameroon"
                        />
                        <span>+{countryCode}</span>
                      </div>
                      <input
                        className="form-control form-mobile-no"
                        type="number"
                        inputMode="numeric"
                        value={phone ? phone : ""}
                        onChange={handleNumberChange}
                        placeholder="Enter Mobile Number"
                      />
                    </div>
                    {message.message && (
                      <div className="mb-3">
                        <p
                          className={`alert alert-${message.error ? "danger" : "success"}`}
                        >
                          {message.message}
                        </p>{" "}
                      </div>
                    )}
                    {loading ? (
                      <Loader />
                    ) : (
                      <button
                        className="btn btn-primary btn-pm-custom"
                        type="button"
                        onClick={sendOtp}
                        disabled={ButtonDisabled}
                      >
                        Submit
                      </button>
                    )}
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Mtnlb;
